import axios from '@/libs/api.request'

/**
 * 获取角色与菜单的数据
 */
export const getRoleMenuData = (roleId) => {
    const data = {
        'roleId': roleId
    }
    return axios.request({
        url: '/api/admin/role/jurisdiction',
        data,
        method: 'post'
    })
}